// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"337":"88f893b6346de4fc","653":"3a9e5db924ad0f32","931":"e0549f881a9595e6"}[chunkId] + ".css";
};